import Vue from 'vue'
import { IContentSampleTypesGrid, ICreatePatchContentSampleTypesGrid } from '@/modules/configurationModule/detail/samples/samplesTypes/SampleTypes.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class SampleTypesConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any): Promise<IResponseAgGrid<IContentSampleTypesGrid>> {
        const response = await this.axios.put(`/configuration/sampleTypes`, filterModel, { params })
        return response.data
    }
    async patchSampleTypesBatch(request: ICreatePatchContentSampleTypesGrid[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/sampleTypes/batch`, request)
        return response.data
    }
    async createSampleTypes(request: ICreatePatchContentSampleTypesGrid): Promise<IContentSampleTypesGrid> {
        const response = await this.axios.post(`/configuration/sampleTypes`, request)
        return response.data
    }
    async deleteSampleTypesBatch(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/sampleTypes/batch`, { data: request })
        return response.data
    }
}

export const sampleTypesConfigurationServices = new SampleTypesConfigurationServices()
